var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconAnalysisFailed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F79009"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1425_66905)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1425_66905",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 9,
    width: 14,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 9H23V23H9V9Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1425_66905)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6875 10.3125V16.3612L12.7347 14.6875L12.3472 14.3553C12.2555 14.2766 12.1494 14.242 12.0289 14.2513C11.9085 14.2605 11.8089 14.311 11.7303 14.4027C11.6517 14.4945 11.617 14.6006 11.6263 14.721C11.6355 14.8415 11.686 14.941 11.7778 15.0197L14.833 17.6384C14.9149 17.7128 15.0123 17.75 15.125 17.75C15.2379 17.75 15.3353 17.7127 15.4173 17.6381L18.4722 15.0197C18.5639 14.941 18.6145 14.8415 18.6237 14.721C18.633 14.6006 18.5983 14.4945 18.5196 14.4027C18.441 14.311 18.3415 14.2605 18.2211 14.2513C18.1006 14.242 17.9945 14.2766 17.9028 14.3553L17.5152 14.6875L15.5625 16.3612V10.3125C15.5625 10.1917 15.5198 10.0886 15.4344 10.0031C15.3489 9.91771 15.2458 9.875 15.125 9.875C15.0042 9.875 14.9011 9.91771 14.8156 10.0031C14.7302 10.0886 14.6875 10.1917 14.6875 10.3125ZM16.4656 19.9375H11.6246C10.7499 19.9375 10.3125 19.5001 10.3125 18.6254V17.75C10.3125 17.6292 10.3552 17.5261 10.4406 17.4406C10.5261 17.3552 10.6292 17.3125 10.75 17.3125C10.8708 17.3125 10.9739 17.3552 11.0594 17.4406C11.1448 17.5261 11.1875 17.6292 11.1875 17.75V18.6254C11.1875 18.9168 11.3332 19.0625 11.6246 19.0625H16.4656C16.5527 18.4026 16.8424 17.8266 17.3345 17.3345C17.9325 16.7365 18.6543 16.4375 19.5 16.4375C20.3457 16.4375 21.0675 16.7365 21.6655 17.3345C22.2635 17.9325 22.5625 18.6543 22.5625 19.5C22.5625 20.3457 22.2635 21.0675 21.6655 21.6655C21.0675 22.2635 20.3457 22.5625 19.5 22.5625C18.6543 22.5625 17.9325 22.2635 17.3345 21.6655C16.8424 21.1734 16.5527 20.5974 16.4656 19.9375ZM20.1718 18.3156L19.5531 18.9343L18.9344 18.3156C18.8489 18.2302 18.7458 18.1875 18.625 18.1875C18.5042 18.1875 18.4011 18.2302 18.3156 18.3156C18.2302 18.401 18.1875 18.5041 18.1875 18.625C18.1875 18.7458 18.2302 18.8489 18.3156 18.9343L18.9344 19.553L18.3156 20.1717C18.2302 20.2572 18.1875 20.3603 18.1875 20.4811C18.1875 20.6019 18.2302 20.7051 18.3156 20.7905C18.4011 20.8759 18.5042 20.9186 18.625 20.9186C18.7458 20.9186 18.8489 20.8759 18.9344 20.7905L19.5531 20.1717L20.1718 20.7905C20.2572 20.8759 20.3603 20.9186 20.4811 20.9186C20.602 20.9186 20.7051 20.8759 20.7905 20.7905C20.8759 20.7051 20.9186 20.6019 20.9186 20.4811C20.9186 20.3603 20.8759 20.2572 20.7905 20.1717L20.1718 19.553L20.7905 18.9343C20.8759 18.8489 20.9186 18.7458 20.9186 18.625C20.9186 18.5041 20.8759 18.401 20.7905 18.3156C20.7051 18.2302 20.602 18.1875 20.4811 18.1875C20.3603 18.1875 20.2572 18.2302 20.1718 18.3156Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1425_66905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(9 9)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconAnalysisFailed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_analysis_failed.df50bb59409668c112ab70009d642920.svg";